import React, { useState } from "react";
import wechatQR from "./wechatqr.jpg";
import "./floating.css";

export default function WeChatChatButton() {
  const [showQR, setShowQR] = useState(false);

  return (
    <div className="floating-wechat">
      {/* زر المحادثة */}
      <button
        onClick={() => setShowQR(!showQR)}
        className="floating-chat floating-chat--wechat"
        aria-label="WeChat QR"
        aria-expanded={showQR}
      >
        💬
      </button>

      {/* نافذة الكود */}
      {showQR && (
        <div className="floating-wechat__panel">
          <img src={wechatQR} alt="WeChat QR" />
        </div>
      )}
    </div>
  );
}
